import { Component, ElementRef, Input, OnInit, EventEmitter, TemplateRef, ViewChild, Output } from '@angular/core';
import { Stripe, StripeElements, StripeCardNumberElement, StripeCardExpiryElement, StripeCardCvcElement } from '@stripe/stripe-js';
import { SubscriptionService } from '../../services/subscription.service';
import { AuthService } from '../../services/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { User } from '../../models/user';
import { AppSettingsService } from '../../services/app-settings.service';
import { RegistrationService } from '../../services/Registration.service';

declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-subscription',
    templateUrl: './subscription.component.html',
    styleUrls: ['subscription.component.css']
})
export class SubscriptionComponent implements OnInit {
    @ViewChild('cardNumberElement') cardNumberElement: ElementRef;
    @ViewChild('cardExpiryElement') cardExpiryElement: ElementRef;
    @ViewChild('cardCvcElement') cardCvcElement: ElementRef;

    // Accepting subscriptionDetails and userName as inputs
    @Input() public subscriptionDetails: any;
    @Input() public userName: string;

    @Output() subscriptionDetailsChange = new EventEmitter<{ dailyReport: boolean }>();

    currentUser: User;
    public isAddDaysView: boolean = false;
    public isAddDaysChecked: boolean = false;
    public daysToPurchase: number = 0;
    public totalPaymentAmount: number = 0;
    public errorMessage: string | null = null;
    public username = null;
    
    private stripe: Stripe | null = null;
    private elements: StripeElements | null = null;

    private cardNumber: StripeCardNumberElement | null = null;
    private cardExpiry: StripeCardExpiryElement | null = null;
    private cardCvc: StripeCardCvcElement | null = null;
    public purchaseAccountLevel;
    public Pricing;
    public purchase_option: any;
    public isShowUpgradeOptions: boolean = true;

    constructor(private authService: AuthService,
        private subscriptionService: SubscriptionService,
        private appSettings: AppSettingsService,
        private registrationService: RegistrationService,
        private spinnerService: Ng4LoadingSpinnerService,) { 
            this.username = this.authService.currentUser.userName;
        }

    async ngOnInit() {
        this.stripe = await this.subscriptionService.getStripeInstance();
        this.Pricing = this.appSettings.getConfig("PRICING_SETTING");
        this.authService.currentUserObj.subscribe(res => {
            if (res === 'string') {
              this.currentUser = JSON.parse(res);
              // console.log(res);
            } else {
              this.currentUser = res;
            }
            // console.log('user aupdate');
            // console.log(this.currentUser);
            // console.log('====================================');
          });
    }

    async ngAfterViewInit() {
        // Stripe elements will be initialized when `isAddDaysView` becomes true
        $('.selectpicker').selectpicker('refresh');
    }

    async addMoreDays(role) {
        this.isAddDaysView = true;
        this.daysToPurchase = 0;
        this.totalPaymentAmount = 0;
        // Initialize Stripe elements after `isAddDaysView` is true and elements are in the DOM
        this.setupStripeElement();
        // var options = [];
        
        if(role) {
            if(role === 'acc-upgrd') {
                $("#subscriptionModalTitle").text('Account: Upgrade Account');
                this.purchaseAccountLevel = this.currentUser.userRole.toUpperCase();
                this.purchase_option = role;
                this.isShowUpgradeOptions = true;

                if(this.subscriptionDetails.accountDaysRemaining === 0) {
                    this.isAddDaysChecked = true;    
                } else {
                    this.isAddDaysChecked = false;
                }

                // if(this.purchaseAccountLevel === 'GROWTH') {
                //     options = [
                //         { value: 'GROWTH', text: 'GROWTH' },
                //         { value: 'PRO', text: 'PRO' }
                //     ];
                // } else if(this.purchaseAccountLevel === 'PRO') {
                //     options = [
                //         { value: 'PRO', text: 'PRO' }
                //     ];
                // } else {
                //     options = [
                //         { value: 'ESSENTIAL', text: 'ESSENTIAL' },
                //         { value: 'GROWTH', text: 'GROWTH' },
                //         { value: 'PRO', text: 'PRO' }
                //     ];
                // }
            } else if(role === 'add_days') {
                $("#subscriptionModalTitle").text('Account: Add Days');
                this.purchaseAccountLevel = this.currentUser.userRole.toUpperCase();
                this.purchase_option = role;
                this.isShowUpgradeOptions = false;
                this.isAddDaysChecked = true;

                // options = [
                //     { value: this.purchaseAccountLevel, text: this.purchaseAccountLevel }
                // ];
            } else {
                $("#subscriptionModalTitle").text('Account: Upgrade Account');
                this.purchaseAccountLevel = role.toUpperCase();
                this.purchase_option = role.toUpperCase();
                this.isShowUpgradeOptions = true;
                if(this.subscriptionDetails.accountDaysRemaining === 0) {
                    this.isAddDaysChecked = true;    
                } else {
                    this.isAddDaysChecked = false;
                }

                this.calculateTotalPaymentAmount();

                // options = [
                //     { value: this.purchaseAccountLevel, text: this.purchaseAccountLevel }
                // ];
            }
        } else {
            this.purchaseAccountLevel = '';
            this.purchase_option = '';
            this.isShowUpgradeOptions = false;
            this.isAddDaysChecked = false;
        }

        setTimeout(() => {
            // $('#ddlPurchaseAccountLevel').empty();
            // $('#ddlPurchaseAccountLevel').append('<option value="" disabled selected>-- Select Upgrade --</option>');
            // $.each(options, function(i, item) {
            //     $('#ddlPurchaseAccountLevel').append(
            //         $('<option>', {
            //             value: item.value,
            //             text: item.text
            //         })
            //     );
            // });

            $('#ddlPurchaseAccountLevel').val(this.purchaseAccountLevel).trigger('change');
            $('.selectpicker').selectpicker('refresh');
        }, 500);
    }

    async showAccountSettings() {
        this.isAddDaysView = false;
        $("#subscriptionModalTitle").text('Account');
    }

    private async setupStripeElement() {
        if (!this.stripe) {
            this.authService.showNotification('', 'Stripe instance is not available.', 'error');
            return;
        }

        this.elements = this.stripe.elements();

        // Ensure the view is fully loaded and elements are in the DOM
        setTimeout(() => {
            if (this.cardNumberElement && this.cardExpiryElement && this.cardCvcElement) {
                this.cardNumber = this.elements.create('cardNumber');
                this.cardNumber.mount(this.cardNumberElement.nativeElement);

                this.cardExpiry = this.elements.create('cardExpiry');
                this.cardExpiry.mount(this.cardExpiryElement.nativeElement);

                this.cardCvc = this.elements.create('cardCvc');
                this.cardCvc.mount(this.cardCvcElement.nativeElement);
            }
        }, 0);
    }

    async handleAccountSubscriptionSubmit(event: Event) {
        event.preventDefault();

        // Call the PaymentService to create the token
        if (this.cardNumber) {

            // var max = 365;
            // var min = 7;
            // if (this.daysToPurchase < min || this.daysToPurchase > max) {
            //     this.spinnerService.hide();
            //     this.authService.showNotification('', 'Number of days should be between </br> 7 and 365', 'error');
            //     return;
            // }

            this.registrationService.getRegisteredPlayersByUser(this.userName).subscribe((response) => {
                if(this.Pricing[this.purchaseAccountLevel] <= this.Pricing[this.currentUser.userRole.toUpperCase()]
                    && this.Pricing[this.purchaseAccountLevel] === 'ESSENTIAL'
                    && response.data.length >= 5) {
                    this.authService.showNotification('', 'You have more than 5 registered players', 'error');
                    return;
                }
            });

            this.spinnerService.show();
            const { token, error } = await this.subscriptionService.createPaymentToken(this.cardNumber);

            if (error) {
                this.spinnerService.hide();
                this.authService.showNotification('', 'Some error occured please try again later', 'error');
                console.log('Payment Error:', error);
            } else if (token) {
                let request = {
                    token: token.id,
                    userName: this.userName,
                    noOfDaysToPurchase: this.daysToPurchase,
                    amountToPay: this.totalPaymentAmount,
                    purchaseLevel: this.purchaseAccountLevel,
                    FirstName: $("#txtFirstName").val(),
                    LastName: $("#txtLastName").val(),
                    Address: $("#txtAddress").val(),
                    Address2: $("#txtAddress2").val(),
                    Country: $("#txtCountry").val(),
                    City: $("#txtCity").val(),
                    State: $("#txtState").val(),
                    Zip: $("#txtZip").val()
                }

                this.subscriptionService.processPayment(request).subscribe(
                    (response) => this.handleProcessPaymentResponse(response),
                    (err) => this.handleProcessPaymentError(err)
                );
            }
        }
    }
    
    handleProcessPaymentResponse(response: any) {
        this.spinnerService.hide();

        if (response.status == "success") {
            this.authService.showNotification('', response.message, 'success');
            this.spinnerService.show();

            this.subscriptionService.getSubscriptionDetails(this.userName).subscribe(
                (response) => {
                    if (response && response.data) {
                        this.subscriptionDetails = response.data;
                        this.daysToPurchase = 1;
                        this.isAddDaysView = false;
                        this.spinnerService.hide();
                    }
                },
                (error) => {
                    this.spinnerService.hide();
                    this.authService.showNotification('', 'Some error occured please try again later', 'error');
                }
            );
        } else {
            this.authService.showNotification('', response.message, 'error');
        }
    }
    
    handleProcessPaymentError(error) {
        console.log('Payment error:', error)
        this.spinnerService.hide();
        this.authService.showNotification('', 'Some error occured please try again later', 'error');
    }

    isValid(): boolean {
        
        this.errorMessage = null;
        if($("#txtFirstName").val() === '') {
            this.errorMessage = 'First Name is mandatory.';
            return false;
        }
        if($("#txtLastName").val() === '') {
            this.errorMessage = 'Last Name is mandatory.';
            return false;
        }
        if (this.totalPaymentAmount === null || this.totalPaymentAmount === undefined) {
            this.errorMessage = 'Invalid amount.';
            return false;
        }
        if (this.totalPaymentAmount === 0 && 
            this.Pricing[this.purchaseAccountLevel] === this.Pricing[this.currentUser.userRole.toUpperCase()]) {
            this.errorMessage = 'Add days to proceed.';
            return false;
        }
        // if (this.daysToPurchase === null || this.daysToPurchase === undefined) {
        //     this.errorMessage = 'Input cannot be empty.';
        //     return false;
        // }
        // if (this.daysToPurchase < 7) {
        //     this.errorMessage = 'Minimum value is 7.';
        //     return false;
        // }
        // if (this.daysToPurchase > 365) {
        //     this.errorMessage = 'Maximum value is 365.';
        //     return false;
        // }
        return true;
    }

    onToggleDailyReport(event) {
        this.subscriptionDetails.dailyReport = event.target.checked;
        this.subscriptionDetailsChange.emit(this.subscriptionDetails);

        this.saveAccountSettings();
    }
    onToggleAddDays(event) {
        this.isAddDaysChecked = event.target.checked;
        this.daysToPurchase = 0;
        this.calculateTotalPaymentAmount();
    }
    onPlanChange(event) {
        this.calculateTotalPaymentAmount();
    }
    onDaysChange(event) {
        this.calculateTotalPaymentAmount();
    }
    calculateTotalPaymentAmount() {
        var daysRemaining = Number(this.subscriptionDetails.accountDaysRemaining);
        var purchaseDays = Number(this.daysToPurchase);
        // var availableAmount = this.Pricing[this.currentUser.userRole.toUpperCase()] * daysRemaining;
        var changeLevelAmount = this.Pricing[this.purchaseAccountLevel] * daysRemaining;
        var existingPaymentAmount = this.Pricing[this.currentUser.userRole.toUpperCase()] * daysRemaining;
        if(purchaseDays === 365) {
            purchaseDays = purchaseDays - 60;
        }
        var purchaseDaysAmount = this.Pricing[this.purchaseAccountLevel] * purchaseDays;
        
        if(this.Pricing[this.purchaseAccountLevel] <= this.Pricing[this.currentUser.userRole.toUpperCase()]) { //downgrade
            this.totalPaymentAmount = purchaseDaysAmount;
        } else {
            var requiredAmount = changeLevelAmount + purchaseDaysAmount - existingPaymentAmount;
            this.totalPaymentAmount = requiredAmount;
        }
    }

    saveAccountSettings() {
        this.spinnerService.show();
        this.subscriptionService.UpdateAccountSettings(this.subscriptionDetails).subscribe((response) => {
            this.spinnerService.hide();
            if (response.status === 'error') {
                this.authService.showNotification(response.message, '', 'error');
            } else {
                // $("button.close").click();
                this.authService.showNotification('Account settings saved successfully', 'success', 'success');
            }
          }, error => {
              this.spinnerService.hide();
              this.authService.showNotification('', 'Some error occured. please try again later', 'error');
        });
    }

    btnFullYearClick() {
        this.daysToPurchase = 365;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/subscription/subscription.component.ts